import React from 'react'
import { csx } from '@vtex/admin-ui'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'

import { NavButton } from './NavButton'
import { CloseButton } from './CloseButton'
import { ProductSkuImageGalleryImage } from './ProductSkuImageGalleryImage'
import type { ProductSkuImagesGallery_ProductSkuImageConnection$key } from './__generated__/ProductSkuImagesGallery_ProductSkuImageConnection.graphql'
import { ProductSkuImageGalleryPaginator } from './ProductSkuImageGalleryPaginator'
import type { ProducSkuImageDesktopProps_ProductSku$data } from '../ProducSkuImageDesktop/__generated__/ProducSkuImageDesktopProps_ProductSku.graphql'

const productSkuImageConnectionFragment = graphql`
  fragment ProductSkuImagesGallery_ProductSkuImageConnection on ProductSkuImageConnection {
    ...ProductSkuImageGalleryPaginator_ProductSkuImageConnection
  }
`

export type ProductSkuImagesGalleryProps = {
  activeSkuImage: ProducSkuImageDesktopProps_ProductSku$data['images']['edges'][number]['node']
  onCloseGallery: () => void
  onNextImageClick: () => void
  onPreviousImageClick: () => void
  productSkuImageConnectionRef: ProductSkuImagesGallery_ProductSkuImageConnection$key
}

export const ProductSkuImagesGallery = ({
  activeSkuImage,
  onCloseGallery,
  onNextImageClick,
  onPreviousImageClick,
  productSkuImageConnectionRef,
}: ProductSkuImagesGalleryProps) => {
  const productSkuImageConnection = useSuspenseFragment(
    productSkuImageConnectionFragment,
    productSkuImageConnectionRef
  )

  return (
    <div
      className={csx({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'white',
        zIndex: 5,
        userSelect: 'none',
      })}
    >
      <CloseButton onClick={onCloseGallery} />
      <NavButton direction="prev" onClick={onPreviousImageClick} />
      <NavButton direction="next" onClick={onNextImageClick} />
      <ProductSkuImageGalleryImage activeSkuImage={activeSkuImage} />
      <ProductSkuImageGalleryPaginator
        activeImageUrl={activeSkuImage.urlFullSize}
        productSkuImageConnectionRef={productSkuImageConnection}
      />
    </div>
  )
}
